import script from "./ChooseCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseCompany.vue?vue&type=script&setup=true&lang=js"

import "./ChooseCompany.vue?vue&type=style&index=0&id=329b4d3e&scoped=true&lang=css"
import "./ChooseCompany.vue?vue&type=style&index=1&id=329b4d3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329b4d3e"]])

export default __exports__